import React from 'react'
import PropTypes from 'prop-types'
import Typography from '../Typography'

const GridTable = ({ columns = [], gridCols = 'grid-cols-5', children, bodyClassName = 'bg-white', showActivityData = false }) => {
  // Activity data based on the image
  const activityData = [
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Tenant',
      subRole: 'End User',
      date: 'August 24,2023',
      time: '2:30 pm',
      action: 'Clicked the Button',
      description: 'Viewed the property twice',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Tenant',
      subRole: 'End User',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Agent',
      subRole: 'Apartment Name',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Broker',
      subRole: 'Swap space',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Tenant',
      subRole: 'End User',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Agent',
      subRole: 'Apartment Name',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Admin',
      subRole: 'Community Name',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    },
    {
      username: 'Anslem Raj',
      email: 'anslemraj234@gmail.com',
      role: 'Agent',
      subRole: 'Apartment Name',
      date: 'August 20,2023',
      time: '2:30 pm',
      action: 'Clicked the down arrow',
      description: 'wishlisted the property',
      ipAddress: '23.678954'
    }
  ]

  const getRoleBadgeColor = (role) => {
    switch (role.toLowerCase()) {
      case 'tenant':
        return 'bg-black-100 text-black-800'
      case 'agent':
        return 'bg-black-100 text-black-800'
      case 'broker':
        return 'bg-black-100 text-black-800'
      case 'admin':
        return 'bg-black-100 text-black-800'
      default:
        return 'bg-black-100 text-black-800'
    }
  }

  return (
    <div>
      {/* Header */}
      <div className={`bg-primary rounded-t-lg grid ${gridCols} gap-4 px-8 py-4`}>
        {columns.map((col, idx) => (
          <div key={idx} className={`${col.colSpan || ''} ${col.colStyle || ''}`}>
            <Typography variant="h4" className="text-white">
              {col.colname}
            </Typography>
          </div>
        ))}
      </div>
      
      {/* Body */}
      <div className={`${bodyClassName} border border-gray-300 rounded-b-lg`}>
        {showActivityData ? (
          // Activity-specific data rendering
          <div className="divide-y divide-gray-200">
            {activityData.map((item, index) => (
              <div key={index} className={`grid ${gridCols} gap-4 px-8 py-4 hover:bg-gray-50`}>
                {/* Username & ID column */}
                <div className="flex flex-col">
                  <span className="font-medium text-gray-900">{item.username}</span>
                  <span className="text-sm text-gray-500">{item.email}</span>
                </div>
                
                {/* User Role column */}
                <div className="flex flex-col">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getRoleBadgeColor(item.role)} mb-1 w-fit`}>
                    {item.role}
                  </span>
                  <span className="text-sm text-gray-500">{item.subRole}</span>
                </div>
                
                {/* Date & Time column */}
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-900">{item.date}</span>
                  <span className="text-sm text-gray-500">{item.time}</span>
                </div>
                
                {/* Action column */}
                <div className="flex flex-col">
                  <span className="text-sm text-gray-900">{item.action}</span>
                </div>
                
                {/* Description column */}
                <div className="flex flex-col">
                  <span className="text-sm text-gray-900">{item.description}</span>
                </div>
                
                {/* IP Address column */}
                <div className="flex flex-col">
                  <span className="text-sm text-gray-900">{item.ipAddress}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          // Generic children rendering for other pages
          <div className={`grid ${gridCols} gap-4 px-8 py-4`}>
            {children}
          </div>
        )}
      </div>
    </div>
  )
}

GridTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      colname: PropTypes.string.isRequired,
      colSpan: PropTypes.string,
      colStyle: PropTypes.string,
    })
  ).isRequired,
  gridCols: PropTypes.string,
  children: PropTypes.node,
  bodyClassName: PropTypes.string,
  showActivityData: PropTypes.bool,
}

export default GridTable